export const gridContainerSx = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
};

export const challengeDetailsContainerSx = {
  maxWidth: '250px',
  marginTop: '12px',
};
